"use client";
import React from "react";
import styled from "styled-components";
import { Col } from "react-bootstrap";
import { Img } from "@/components/Img";
import { hover } from "@/styles/globalStyleVars";
import Title from "@/components/Title";
import ThemeRow from "@/components/theme/row";
import reactHtmlParser from "react-html-parser";

const ServiceFeature = ({ data }) => {
  return (
    <StyledOverview className="service-feature pt-200 pb-200">
      <img
        src="/images/static/top.svg"
        alt={'Services Image'}
        className="top-img parallax-xr"
      />
      <img
        src="/images/static/bottom.svg"
        alt={'Services Image'}
        className="bottom-img parallax-x"
      />

      {data?.bg_img && <Img objectFit={"cover"} alt={data?.section_name} src={data?.bg_img} />}
      {data?.section_name && (
        <ThemeRow>
          <Col sm={7}>
            <Title
              text={data?.section_name}
              version
              number={"II"}
              background={"#ffffff33"}
              color={"#FFFFFF"}
            />
          </Col>
        </ThemeRow>
      )}

      <ThemeRow>
        <Col sm={11} className={"feature-list"}>
          {data?.feature_list && data?.feature_list?.length > 0 && (
            <ul className="fade-up">
              {data?.feature_list &&
                data?.feature_list?.length > 0 &&
                data?.feature_list?.map((e, index) => {
                  return <li key={index}>{reactHtmlParser(e?.item)}</li>;
                })}
            </ul>
          )}
        </Col>
      </ThemeRow>
    </StyledOverview>
  );
};

const StyledOverview = styled.section`
  overflow: hidden;
  position: relative;
  background-color: ${hover};
    .title {
        p{
            margin-right: 10px;
        }
        h2 {
            padding: 0 !important;

            &:after , &:before{
                display: none !important;
            }
        }
    }

  .top-img {
    position: absolute;
    top: 0px;
    left: 0%;
    z-index: 1;
  }
  .bottom-img {
    position: absolute;
    top: 200px;
    right: 0%;
    z-index: 1;
  }

  .title {
    h2 {
      padding-left: 40px;

      &:before {
        left: 40px;
      }
    }

    &:after {
      bottom: -67px;
    }
  }

  .feature-list {
    ul {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding-left: 88px;
      margin-top: 80px;
      gap: 70px 80px;

      li {
        position: relative;
        flex: 0 0 calc(33% - 70px);
        color: white;
        font-size: 20px;
        line-height: 28px;
        font-weight: 500;
        counter-increment: count;
        padding-top: 35px;
        &:before {
          content: counter(count, upper-alpha);
          position: absolute;
          height: 25px;
          width: 25px;
          padding: 0;
          background: white;
          border-radius: 50%;
          color: ${hover};
          top: 0;
          left: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          font-weight: 500;
          line-height: 18px;
        }
      }
    }
  }

  @media (max-width: 767px) {
    .feature-list {
      ul {
        padding-left: 0;
        gap: 40px;
        li {
          flex: 0 0 100%;
        }
      }
    }
    .title {
      p {
        &:after {
        }
      }
    }

    h2 {
      padding-left: 0 !important;
    }
  }
`;

export default ServiceFeature;
